const initialValidationPassword = () => {
  return [
    { id: "minLength", isValid: true, msg: "Must be at least 8 charcters" },
    { id: "useUpperCase", isValid: true, msg: "Use upper case (A-Z)" },
    { id: "useLowerCase", isValid: true, msg: "Use lower case (a-z)" },
    { id: "useSpecialChar", isValid: true, msg: "Use special character (# % @ &)" },
    { id: "useNumber", isValid: true, msg: "Use number (0-9)" },
  ];
};

const isEmail = (value) => {
  /* eslint-disable-next-line */
  const exp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return exp.test(value);
};

const isPassword = (value) => {
  /* eslint-disable-next-line */
  const exp = /^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,})(?=(.*[!@#$%^&*()\-__+.]){1,}).{8,}$/;
  return exp.test(value);
};

const isValidPassword = (value) => {
  const validationPassword = initialValidationPassword();
  const regexExp = {
    containsSymbol: /[^\w\s]|_/,
    containsNumber: /[0-9]/,
    containsLowercase: /[a-z]/,
    containsUppercase: /[A-Z]/,
  };
  if (value.length < 8) {
    validationPassword[0].isValid = false;
  }
  if (!regexExp.containsUppercase.test(value)) {
    validationPassword[1].isValid = false;
  }
  if (!regexExp.containsLowercase.test(value)) {
    validationPassword[2].isValid = false;
  }
  if (!regexExp.containsSymbol.test(value)) {
    validationPassword[3].isValid = false;
  }
  if (!regexExp.containsNumber.test(value)) {
    validationPassword[4].isValid = false;
  }

  return validationPassword;
};

const checkNoHp = (value) => {
  if (!/^[0-9]+$/.test(value)) {
    return false;
  }
  if (/^[0-9]+$/.test(value)) {
    return true;
  }

  return value;
}

export { isEmail, isPassword, isValidPassword, initialValidationPassword, checkNoHp };
